export default __webpack_public_path__ + "static/media/down.6f167dc8.svg";